<template>
  <div id="app" class="wrap">
    <!-- 로딩바 -->
    <section class="loading-bg" v-show="loading">
      <loading-bar />
    </section>
    <!-- <div class="loading" v-show="pageLoading"></div> -->
    <!-- <div class="loading" v-show="loading"></div> -->

    <!-- 자동 로그아웃 modal -->
    <auto-logout v-if="isLogin" @logout="autoLogout = true" />

    <!-- 로그아웃 되었습니다 안내 -->
    <modal-pop
      :opened.sync="autoLogout"
      :no-negative-button="true"
      confirm="MCOM-0000093"
      cancel="MCOM-0000003"
      @confirm="
        () => {
          $router.push({ name: 'login' });
        }
      "
    >
      <template #content>
        <div>
          <strong class="text-info">{{ /*로그아웃 되었습니다.*/ $t("MCOM-0000095") }}</strong>
          <!-- 서비스 이용중 다른 화면으로 이동되었거나, <br />최종 사용 후 10분이 경과되어 자동으로 로그아웃 되었습니다. -->
          <p v-html="$t('MCOM-0000096')" />
        </div>
      </template>
    </modal-pop>

    <!-- 로그인 메뉴로 이동 안내 -->
    <modal-pop
      :opened.sync="needLoginModalOpended"
      :no-negative-button="true"
      confirm="MCOM-0000003"
      cancel="MCOM-0000094"
      @confirm="goLogin"
      @cancel="
        () => {
          (needLoginPath = ''), $router.push({ name: 'main', params: { siteCode: this.siteCode, lang: this.lang } });
        }
      "
    >
      <template #content>
        <div>
          <!-- 해당 메뉴를 이용하시려면 <br />로그인이 필요합니다. <br />로그인 화면으로 이동하시겠습니까? -->
          <strong class="text-info" v-html="$t('MCOM-0000105')" />
        </div>
      </template>
    </modal-pop>

    <!-- 거래 오류 modal -->
    <error-modal />

    <!-- Fido 관련 -->
    <fido />

    <!-- 앱 최신 버전일 때  -->
    <!-- <template v-if="$config.MOBILE_APP_RECENT_VERSION === getNativeAll.appVersionCode"> -->
    <router-view />
    <!-- </template>
    <template v-else>-->
    <!-- 앱 업데이트 알림 -->
    <!-- <section class="intro">
        <modal-pop
          :opened.sync="appUpateModal"
          :modal-footer="true"
          class="modal"
          title="MMAIN-01-01-05-01"
          confirm="Open App Store"
          @confirm="$goToMarket(getNativeAll.smphMchtlDstcd)"
        >
          <template #content>
            <div>
              {{/*현재 사용중인 앱 서비스는 최신 버전이 아닙니다.*/$t("MMAIN-01-01-05-02")}}
              <br />
              {{/*서비스의 안정적인 사용을 위해서 앱 스토어를 통해 업데이트를 해주시기 바랍니다.*/$t("MMAIN-01-01-05-03")}}
            </div>
          </template>
        </modal-pop>
      </section>
    </template>-->
     <permission-popup ref="permission"></permission-popup>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";
import AutoLogout from "@/components/modal/AutoLogout";
import ErrorModal from "@/components/modal/ErrorModal";
import Fido from "@/components/page/auth/Fido";
import PermissionPopup from "@/components/page/main/PermissionPopup";
export default {
  name: "App",
  components: {
    AutoLogout,
    ErrorModal,
    Fido,
    PermissionPopup,
  },
  data() {
    return {
      isLogout: false,
      selLang: "",
      abt: "",
      appUpateModal: true,
      env: process.env.NODE_ENV,
    };
  },
  created() {
    // 현재 위치에서 bridge 호출하면 에러납니다..
  },
  mounted() {
    window.app = this;
    this.$lang(); //네이티브 다국어설정
    console.log(this.siteCode);
    // if (this.siteCode == "") {
    //   this.siteCode = sessionStorage.getItem("siteCode");
    //   this.operGroupCd = sessionStorage.getItem("operGroupCd");
    //   this.menu = JSON.parse(sessionStorage.getItem("menu"));
    //   this.lang = sessionStorage.getItem("lang");
    // }
  },
  computed: {
    ...mapFields(["menu", "loading", "pageLoading", "needLoginModalOpended", "needLoginPath", "sessionInfo", "lang", "history", "autoLogout", "operGroupCd", "siteCode"]),
    ...mapGetters(["isLogin"]),
    ...mapGetters("native", ["getNativeAll"]),
  },
  methods: {
    ...mapActions("native", ["actGetNativeData"]),
    goLogin() {
      //로그인 메뉴에서 자동로그아웃 되면 로그인 후 -> 메인으로 이동
      this.$router.push({ name: "login", query: { redirect: this.needLoginPath } });
    },
  },
};
</script>
